import { render } from "./FoodModal.vue?vue&type=template&id=41cc98fd&scoped=true"
import script from "./FoodModal.vue?vue&type=script&lang=js"
export * from "./FoodModal.vue?vue&type=script&lang=js"

import "./FoodModal.vue?vue&type=style&index=0&id=41cc98fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cc98fd"]])

export default __exports__